import { SubHeader } from '@components/header/base/subheader/sub-header.comp';
import { SubheaderItem } from '@components/header/base/subheader/sub-header-item';
import useProcess from '@hooks/useProcess';
import { getWorkflowMenuItems } from '@pages/Settings/menu';
import { hasElevatedRights } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';
import { Outlet, useParams } from 'react-router-dom';

import { useUser } from '@/layout';
import { ParamsList } from '@/routes/routes.types';

export const WorkflowLayout = () => {
  const process = useProcess();
  const { user } = useUser();
  const processId = useParams()[ParamsList.ProcessId] as string;
  const currentWorkflowId = useParams()[ParamsList.WorkflowId];
  const isPrivileged = hasElevatedRights(user);

  const WORKFLOW_MENU_ITEMS = getWorkflowMenuItems({ isPrivileged });

  const navigate = (link: string) =>
    `/${processId}/${currentWorkflowId}/${link}`;

  const canEdit = process?.permission.can_edit;

  return (
    <>
      {canEdit && (
        <SubHeader>
          {WORKFLOW_MENU_ITEMS.map(({ name, link }) => (
            <SubheaderItem
              key={link}
              link={link}
              name={name}
              to={navigate(link)}
            />
          ))}
        </SubHeader>
      )}
      <div className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden">
        <Outlet />
      </div>
    </>
  );
};

export default observer(WorkflowLayout);
